import { Injectable } from '@angular/core';
import { IFormBettings } from '@oogaday/shared';
import { FormBettingResultModel } from 'src/app/common/apis/form/model/form.model';

@Injectable({
  providedIn: 'root'
})
export class SimulateResultsStateService {
  private readonly formsState = new Map<string, SimulateResultsState>();


  getSimulateResults(competitionGroupId: string, formId: string): SimulateResultsState | undefined {
    return this.formsState.get(SimulateResultsStateService.getKey(competitionGroupId, formId))!;
  }

  setSimulatedResults(competitionGroupId: string, formId: string, state: SimulateResultsState): void {
    this.formsState.set(SimulateResultsStateService.getKey(competitionGroupId, formId), state);
  }

  clearSimulatedResults(competitionGroupId: string, formId: string): void {
    this.formsState.delete(SimulateResultsStateService.getKey(competitionGroupId, formId));
  }

  private static getKey(competitionGroupId: string, formId: string): string {
    return `${competitionGroupId}-${formId}`;
  }
}

export interface SimulateResultsState {
  result: IFormBettings<any>;
  bettingResults: FormBettingResultModel[] | undefined;
}
